module.exports = __webpack_public_path__ + "reporting-2-light-bg.740b259aa883d19304ed707ffec62c69.png";